import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { TextField } from 'builder/components/TextField'
import EditorField from 'builder/components/EditorField'
import { actions as editorActions } from 'builder/modules/resumeEditor'

type Props = {
  label: string
  value: string
  name: string
}

export const PersonalEditorField = (props: Props) => {
  const dispatch = useDispatch()
  const { label, value, name } = props
  const handleSimpleFieldUpdate = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target
      dispatch(editorActions.updateSimpleField({ name: name as any, value, debounce: true }))
    },
    [dispatch],
  )

  return (
    <>
      {/* Editor Field */}
      <EditorField>
        <TextField
          label={label}
          value={value || ''}
          name={name}
          onChange={handleSimpleFieldUpdate}
        />
      </EditorField>
    </>
  )
}
